import { AuthRoute } from '@/system-modules/auth/v1/api/AuthRoute'
import { EnumRouteType } from '@/contracts/core/api/enum/EnumRouteType'
import { ApiResponse } from '@/contracts/core/api/entity/ApiResponse'
import { ChangePinsParams } from '@/system-modules/auth/v1/api/v1/auth/ChangePins/Dto/ChangePinsParams'

export class ChangePinsRoute extends AuthRoute<ChangePinsParams, null> {
  type(): EnumRouteType {
    return EnumRouteType.POST
  }

  url(): string {
    return '/api/system/v1/auth/pins/change'
  }

  offline(params: ChangePinsParams): Promise<ApiResponse<null>> {
    if (params.pin === params.resetPin) {
      return Promise.resolve(new ApiResponse({ success: false, error: 'validation_failed' }))
    }

    return Promise.resolve(new ApiResponse({ success: true, data: null }))
  }
}
